export const REGIME_OPTIONS = [
  { value: 'Omnivore', label: 'Omnivore' },
  { value: 'Végétarien', label: 'Végétarien' },
  { value: 'Végan', label: 'Végan' },
  { value: 'Pescétarien', label: 'Pescétarien' },
  { value: 'Halal', label: 'Halal' },
  { value: 'K', label: 'Kasher' }
];

export const TASTE_PROBES = [
  { key: 'coriandre',     label: 'Coriandre' },
  { key: 'olives',        label: 'Olives' },
  { key: 'champignons',   label: 'Champignons' },
  { key: 'tofu',          label: 'Tofu' },
  { key: 'aubergine',     label: 'Aubergine' },
  { key: 'anchois',       label: 'Anchois' },
  { key: 'fromageChevre', label: 'Fromage de chèvre' },
  { key: 'epice',         label: 'Plats très épicés' }
];

export const ALLERGY_OPTIONS = [
  { key: 'arachides', label: 'Arachides' },
  { key: 'fruitsCoque', label: 'Fruits à coque' },
  { key: 'gluten', label: 'Gluten' },
  { key: 'lait', label: 'Lait' },
  { key: 'lactose', label: 'Lactose' },
  { key: 'oeufs', label: 'Œufs' },
  { key: 'poisson', label: 'Poisson' },
  { key: 'crustaces', label: 'Crustacés' },
  { key: 'mollusques', label: 'Mollusques' },
  { key: 'celeri', label: 'Céleri' },
  { key: 'moutarde', label: 'Moutarde' },
  { key: 'sesame', label: 'Sésame' },
  { key: 'soja', label: 'Soja' },
  { key: 'sulfites', label: 'Sulfites' },
  { key: 'lupin', label: 'Lupin' },
  { key: 'fruitsMer', label: 'Fruits de mer' }
];

export const buildAllergiesState = (overrides = {}) => {
  const base = ALLERGY_OPTIONS.reduce((acc, { key }) => {
    acc[key] = false;
    return acc;
  }, {});

  return { ...base, ...(overrides || {}) };
};

export const normalizeAllergies = (allergies) => {
  if (Array.isArray(allergies)) {
    return buildAllergiesState(
      allergies.reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {})
    );
  }

  if (allergies && typeof allergies === 'object') {
    return buildAllergiesState(allergies);
  }

  return buildAllergiesState();
};
